import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
// import videoSource from "../../assets/videos/CS.mp4";
// import videoSource1 from "../../assets/videos/Content_Safety_Demo.mp4";
import architecture from "../../assets/images/resource/content_safety.png";
import FooterOne from "../Footer/FooterOne";
import SorBanner from "./../../assets/images/banner/ai-agents.png";
// import cs from "./../../assets/images/icons/cs.jpg";
// import msa from "./../../assets/images/icons/msa.png";

const ContentSafety = () => {
  pageTitle("Content Safety");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div
        className="ai-overlay-wrapper"
        style={{ backgroundImage: `url(${SorBanner})` }}
      >
        {/* <img src={SorBanner} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          {/* Centered text */}
          {/* <img
            src={msa}
            alt="Microsoft azure"
            className="ai-overlay-corner-img"
          /> */}
          <div className="ai-overlay-center-text">
            <h2 className="aai-h2 mt-0">Content Safety</h2>
           
          </div>
        </div>
      </div>

      <section className="siw-rpa-section">
        <div className="siw-rpa-container-data-engineering container">
          <div className="siw-rpa-content">
            {/* <span className="siw-rpa-tag">
              Still Manually Searching item codes & rates in SOR (Schedule of
              Rates) documents?
            </span> */}

            <div className="siw-rpa-text">
              <p>
                A smart workflow designed to automatically review
                content, detect risks, and trigger safety actions without manual
                effort. This system utilizes AI agent Content Safety to analyze
                material for specific risks like harassment or violence. By
                applying custom decision logic, the platform can automatically
                evaluate these severity scores to determine the appropriate
                response. Ultimately, this service enables seamless operational
                actions, such as blocking harmful users or notifying
                administrators, to maintain a secure digital environment.
              </p>
            </div>

            <div className="siw-rpa-desc">
              <h3 className="pb-2">Key Capabilities</h3>
              <p>
                This solution streamlines content moderation and compliance
                review through an intelligent safety workflow:
              </p>
            </div>
          </div>

          <div className="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>Free Trial Available</h4>
            <p>
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              is currently offering a free trial session. <br />
              Our team will create a dedicated AI Agents.
            </p>
            <p className="siw-project-website-text-top">
              To explore more about the <strong>Content Safety</strong>
              ,
              <br />
              Click 👉{" "}
              <a
                href="https://agents.siw.sg/"
                target="_blank"
                rel="noopener noreferrer"
                className="siw-project-website-link blinking1"
              >
                Content Safety
              </a>
              .
            </p>
            <a href="/contact" className="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Start a Free Trial
            </a>
          </div>
        </div>
      </section>
      <div className="container" style={{ marginTop: "-10px" }}>
        <div className="siw-rpa-desc">
          <p className="py-2" style={{ fontWeight: "bold", color: "#009999" }}>
            The Seven-Step Workflow
          </p>
          <ol>
            <li>
              Data Input – Text, chats, comments, and uploaded content are
              submitted into the workflow.
            </li>
            <li>
              AI Safety Analysis – AI agent analyzes content for risks such as
              violence, hate speech, and harmful language.
            </li>
            <li>
              Safety Scoring – Moderation scores are assigned based on the
              severity of detected content.
            </li>
            <li>
              Decision Logic – Workflow rules classify content into low, medium,
              or high-risk categories.
            </li>
            <li>
              Automated Actions – The system can flag content, send alerts,
              update records, or mute problematic users automatically.
            </li>
            <li>
              Serverless Workflow – Logic Apps or Functions automate
              the end-to-end compliance review process.
            </li>
            <li>
              Monitoring & Insights – Logs, metrics, and analytics provide
              visibility into workflow performance and moderation outcomes.
            </li>
          </ol>
          <h3 style={{ marginTop: "-10px" }}>Architecture</h3>
          <p className="pt-2">
            This architectural diagram outlines a comprehensive framework for
            automatically managing online safety by processing data through two
            distinct stages. The initial phase utilizes AI-powered analysis to
            evaluate incoming information for specific risks, such as violence
            or hate speech, and assigns a corresponding safety score. Based on
            these scores, the system employs conditional decision logic to
            categorize the level of danger as low, medium, or high. Finally, the
            workflow executes automated mitigation actions, ranging from simple
            database updates to silencing problematic users, to ensure a secure
            digital environment without requiring manual intervention.
          </p>
          <img
            src={architecture}
            alt="Computer Vision"
            className="siw-rpa-desc-img"
          />
        </div>
      </div>

      <section className="siw-project-section">
        <div className="siw-project-container container">
          <div className="row g-4 align-items-start">
            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">
                Introducing Content Safety
              </h3>

              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/vLyw1G-coA0?si=QA3IvTDMfcD826Zj"
                  title="Introducing Content Safety"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">Watch a Demo Video</h3>

              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/XLe8F_rN8sU?si=jKhDdIxTRfkK_R1R"
                  title="Watch a Demo Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
          <p className="siw-project-website-text">
            To explore more about the <strong>Content Safety</strong>,
            Click 👉{" "}
            <a
              href="https://agents.siw.sg/"
              target="_blank"
              rel="noopener noreferrer"
              className="siw-project-website-link blinking"
            >
              Content Safety
            </a>
            .
          </p>
        </div>
      </section>
      <FooterOne></FooterOne>
    </>
  );
};
export default ContentSafety;
